/* White card: radius 6, 1 px border (.card). */
.card {
  position: relative;
  min-width: 0;
  background: var(--surface-card);
  border: 1px solid var(--border-card);
  border-radius: var(--radius-md);
}

.accentGold {
  overflow: hidden;
}

.accentGold::before,
.accentCyan::before {
  content: '';
  display: block;
  height: 4px;
  background: var(--brand-gold);
}

.accentCyan {
  overflow: hidden;
}

.accentCyan::before {
  background: var(--brand-cyan);
}

/* Not set yet (e.g. a budget pool): grey the card and link to where it's set. */
.notSet {
  border-style: dashed;
  border-color: var(--border-dashed);
  background: var(--surface-ground);
}

.notSet .title {
  color: var(--text-muted);
}

.dark {
  border-color: transparent;
  background: var(--brand-navy);
  color: var(--white);
}

.dark .title {
  color: var(--white);
}

.media {
  display: block;
  width: 100%;
  height: 220px;
  object-fit: cover;
  object-position: center 30%;
  border-radius: calc(var(--radius-md) - 1px) calc(var(--radius-md) - 1px) 0 0;
}

.body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px 28px;
}

.compact .body {
  padding: 22px 24px;
}

.head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 12px;
}

/* The heading wraps its own words; its badge and "?" stay beside it rather than dropping onto a
   line of their own in a narrow card (R1's Executive pool card). */
.titleRow {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.titleRow > * {
  flex-shrink: 0;
}

.title {
  flex-shrink: 1;
  min-width: 0;
  margin: 0;
  /* R153: a word longer than the card (a file name carrying an id) breaks rather than running
     past the edge. break-word leaves min-content alone, so nothing else moves. */
  overflow-wrap: break-word;
  color: var(--text-heading);
  font-family: var(--font-display);
  font-size: 24px;
  font-weight: var(--fw-medium);
  line-height: 1.15;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}
.title:focus-visible {
  outline: 2px solid var(--focus-ring-color);
  outline-offset: 3px;
  border-radius: 2px;
}

.titleMd .title {
  font-size: 22px;
}

.titleSm .title {
  font-size: 20px;
}

.aside {
  color: var(--text-muted);
  font-size: 13px;
}

/* A navy band across the top (SYS6's person, SYS2's "What can this person do"): the heading, its
   "?" and the band's content on navy, bled to the card's edges; the rest stays white. */
.banded {
  overflow: hidden;
}

.band {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin: -24px -28px 4px;
  padding: 24px 28px;
  background: var(--brand-navy);
  color: var(--white);
}

.compact .band {
  margin: -22px -24px 4px;
  padding: 22px 24px;
}

.band .title {
  color: var(--white);
}

.band .aside {
  color: var(--brand-mist);
}

/* A field in the band (SYS2's person picker): its label white, its hint pale. */
.band label {
  color: var(--white);
}

.band [slot='description'] {
  color: var(--brand-mist);
}
